import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { IVendor, IVendorAllData, IVendorUpdate } from './interfaces';

const basePath = '/vendor';

/* eslint-disable implicit-arrow-linebreak */

export const getVendors = (): AxiosPromise<IApiResponse<IVendorAllData[]>> =>
  vaultApi.getInstance().get(`${basePath}`);

export const getVendorsWithTeamId = (): AxiosPromise<IApiResponse<IVendor[]>> =>
  vaultApi.getInstance().get(`${basePath}/teamId`);

export const optInToVendor = (vendorData: IVendorUpdate): AxiosPromise<IApiResponse<IVendor[]>> =>
  vaultApi.getInstance().put(`${basePath}/optIn`, <IVendorUpdate>vendorData);

export const optOutWithVendor = (vendorData: IVendorUpdate): AxiosPromise<IApiResponse<IVendor[]>> =>
  vaultApi.getInstance().put(`${basePath}/optOut`, <IVendorUpdate>vendorData);
